import * as React from "react";
import { KennelApi, KennelSearch, KennelGridDto } from "../../../../api";
import { useApiService, useTl } from "../../../../hooks";
import { useHistory } from "react-router";
import { useGlobalData } from "../../../../contexts";
import { IDataTableColumn, ButtonContainer } from "nsitools-react";
import { ViewButton, EditButton, SearchTablePage } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import { ETLCodes } from "../../../../locales";
import { Link } from "react-router-dom";
import { Checkbox } from "@blueprintjs/core";

export interface IKennelListPageProps {}

export const KennelListPage: React.FunctionComponent<IKennelListPageProps> = (props) => {
  const kennelApi = useApiService(KennelApi);
  const { t, tUnsafe } = useTl();
  const history = useHistory();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: KennelGridDto) => (
          <ButtonContainer>
            <ViewButton minimal={true} onClick={() => history.push(`${ERoutes.kennel}/${row.kennelId}/detail/view`)} />
            <EditButton minimal={true} onClick={() => history.push(`${ERoutes.kennel}/${row.kennelId}/detail/edit`)} />
          </ButtonContainer>
        ),
      },
      {
        computed: true,
        disableSorting: true,
        header: () => t(ETLCodes.Closed),
        headerAlignment: "center",
        alignment: "center",
        fieldName: "isClosed",
        render: (row: KennelGridDto) => <Checkbox checked={row.isClosed} disabled />,
      },
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
      },
      {
        header: () => t(ETLCodes.Type),
        fieldName: "type",
        render: (row: KennelGridDto) => <div>{tUnsafe(row.type)}</div>,
      },
      {
        header: () => t(ETLCodes.Country),
        fieldName: "country",
        render: (dto: KennelGridDto) => (
          <Link target="_blank" to={`${ERoutes.country}/${dto.countryId}/detail/view`}>
            {dto.country}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.FciNumber),
        fieldName: "fciNumber",
      },
      {
        header: () => t(ETLCodes.AttributionDate),
        fieldName: "attributionDate",
      },
      {
        header: () => t(ETLCodes.ClosingDate),
        fieldName: "closingDate",
      },
    ],
    [history, t, tUnsafe]
  );

  const search = React.useCallback(
    (sObj) => {
      return kennelApi.baseSearch(KennelSearch.fromJS({ ...sObj, languageCode: currentLanguage.languageCode }));
    },
    [currentLanguage.languageCode, kennelApi]
  );

  return (
    <SearchTablePage
      columns={columns}
      searchFunction={search}
      exportFunction={(sObj) => {
        return kennelApi.exportXlsFile(KennelSearch.fromJS({ ...sObj, languageCode: currentLanguage.languageCode }));
      }}
      getCriteriasFunction={() => kennelApi.getSearchCriterias(true)}
      sortKeys={{ name: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.Kennels) }]}
    />
  );
};
